import {ContentType, HttpMethod, HttpService} from "./HttpService";
import {GenerateReferralCodeRequest, ReferralCodeResponse, ReferralData, ReferralValidation} from "../model/user/referrals/Referrals";

export class ReferralService {
    public static generateReferralCode(request: GenerateReferralCodeRequest): Promise<ReferralCodeResponse> {
        return HttpService.sendRequest<ReferralCodeResponse>(
            HttpMethod.POST,
            '/api/referrals/generate',
            JSON.stringify(request),
            ContentType.JSON
        );
    }

    public static getReferralData(): Promise<ReferralData> {
        return HttpService.sendRequest<ReferralData>(
            HttpMethod.GET,
            '/api/referrals'
        );
    }

    public static validateReferralCode(code: string): Promise<ReferralValidation> {
        return HttpService.sendRequest<ReferralValidation>(
            HttpMethod.POST,
            '/api/referrals/validate',
            JSON.stringify({code}),
            ContentType.JSON
        );
    }
}